<div class="row">
  <div class="col-12">
    <div class="receipt-container">
      <!-- Receipt Header -->
      <div class="receipt-header">
        <h3 class="receipt-title">{{ 'i18n.domain.fast-checkin-session.closed-session-title' | translate }}</h3>
      </div>

      <!-- Receipt Body -->
      <div class="receipt-body">
        <!-- Zone -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.shared.fields.zone' | translate }}</span>
          <span class="receipt-value">{{ sessionInfo.zoneName }}</span>
        </div>

        <!-- Control Plate -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.shared.fields.control-plate' | translate }}</span>
          <span class="receipt-value">{{ sessionInfo.controlPlateNumber }}</span>
        </div>

        <div class="receipt-divider"></div>

        <!-- Start Time -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.domain.fast-checkin-session.start-time' | translate }}</span>
          <span class="receipt-value">{{ sessionInfo.startDateTime?.toFormat('dd.MM.yyyy HH:mm') }}</span>
        </div>

        <!-- End Time -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.domain.fast-checkin-session.end-time' | translate }}</span>
          <span class="receipt-value">{{ sessionInfo.endDateTime?.toFormat('dd.MM.yyyy HH:mm') }}</span>
        </div>

        <!-- Duration -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.domain.fast-checkin-session.duration' | translate }}</span>
          <span class="receipt-value">{{ getClosedSessionDuration() }}</span>
        </div>

        <div class="receipt-divider"></div>

        <!-- Close Action -->
        <div class="receipt-row">
          <span class="receipt-label">{{ 'i18n.domain.fast-checkin-session.close-action' | translate }}</span>
          <span class="receipt-value">{{ closingAction | translate }}</span>
        </div>

        <div class="receipt-divider-bold"></div>

        <!-- Total Price -->
        <div class="receipt-row receipt-total">
          <div class="receipt-total-left">
            <div class="receipt-label-total">{{ 'i18n.domain.fast-checkin-session.total-price' | translate }}</div>
            <div class="receipt-vat-text">{{ 'i18n.domain.fast-checkin-session.vat-included' | translate }}</div>
          </div>
          <span class="receipt-value-total">{{ sessionPriceWithCurrency }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
